import { z } from 'zod';
// Names may contain only letters (including accented ones), spaces, hyphens and apostrophes —
// no digits or other symbols. The `u` flag makes \p{L}/\p{M} match accented and composed
// characters, so "João", "Ana-Maria", "D'Ávila" and "Conceição" all pass while "Rodr!go" or
// "Joao2" do not.
const NAME_ALLOWED_CHARS_REGEX = /^[\p{L}\p{M} '-]*$/u;
const NAME_ALLOWED_CHARS_MESSAGE = 'O nome pode conter apenas letras, espaços, hifens e apóstrofos.';
// Single source of truth for person/user names: trimmed, 2–100 chars, allowed characters only.
// Derive the variants you need at the use site, e.g. `NameSchema.nullable()` for an optional
// mother name or `NameSchema.optional()` for a conditionally-required form field.
export const NameSchema = z
    .string()
    .trim()
    .min(2, 'O nome deve ter no mínimo 2 caracteres.')
    .max(100, 'O nome deve ter no máximo 100 caracteres.')
    .regex(NAME_ALLOWED_CHARS_REGEX, NAME_ALLOWED_CHARS_MESSAGE);
//# sourceMappingURL=name.js.map